<template>
	<div class="process-node">
		<h3 class="diagnosis-title">流程节点</h3>
		<div class="diagnosis-lengends">
			<div class="lengend" v-for="item in statusLengends" :key="item.name">
				<em :style="{ backgroundColor: item.color }"></em>
				<span>{{ item.name }}</span>
			</div>
		</div>
		<div class="process-node-flowchart">
			<div class="chart-image">
				<div class="content">
					<img class="bg" :src="detail.sendToGccp === '2' ? FlowChartBg1 : FlowChartBg" alt="" />
					<div
						class="node"
						v-for="item in nodes"
						:key="item.id"
						:style="{ left: item.x, top: item.y }"
						:class="{ fail: item.isFault }"
						@click="toAnalyzeDetail(item)"
					>
						<p>{{ item.name }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { statusLengends, processNodes } from './config'
import FlowChartBg from '@/assets/imgs/bg/flowchart.png'
import FlowChartBg1 from '@/assets/imgs/bg/flowchart1.png'
export default {
	props: {
		detail: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			FlowChartBg,
			FlowChartBg1,
			statusLengends,
		}
	},
	computed: {
		nodes() {
			const nodeStatusMap = this.detail.nodeStatusMap || {}
			return processNodes
				.filter(m => (this.detail.sendToGccp === '2' ? m.id : m.id !== '7'))
				.map(item => {
					const isFault = item.isRealNode && nodeStatusMap[item.id] === 2
					return {
						...item,
						isFault,
					}
				})
		},
	},
	methods: {
		toAnalyzeDetail(item) {
			if (item.noDetails) return
			const { deviceId } = this.detail
			this.$router.push({
				path: '/communicate-diagnosis/analyze-details',
				query: {
					deviceId,
					node: item.id,
				},
			})
		},
	},
}
</script>
<style lang="scss" scoped>
.process-node {
	padding-top: 20px;
	.process-node-flowchart {
		background-color: #f4f6fb80;
		border-radius: 6px;
		.chart-image {
			padding: 12px;
			.content {
				width: fit-content;
				margin: 0 auto;
				position: relative;
				font-size: 0;
				.bg {
					max-width: 100%;
					display: block;
				}
				.node {
					position: absolute;
					z-index: 9;
					padding: 10px 16px;
					background-color: #e2e8fb;
					cursor: pointer;
					border-radius: 4px;
					transform: translate(-50%, -50%);
					&.fail {
						background-color: #ffe8de;
						p {
							color: #e5662e;
						}
					}
					p {
						color: #2b57e8;
						font-size: 14px;
						white-space: pre-wrap;
						line-height: 20px;
					}
				}
			}
		}
	}
}
</style>
